import React from 'react';
import { colors } from 'seedling/constants';

const MoveIcon = ({ color, width, height, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
  >
    <path
      fill={color}
      d="M10.5494505,7.09383632 L10.5494505,12.9061637 L11.5519829,11.9036313 C11.7751397,11.6804746 12.1369482,11.6804746 12.360105,11.9036313 C12.5832617,12.126788 12.5832617,12.4885966 12.360105,12.7117533 L10.382083,14.6897753 C10.1589263,14.912932 9.7971177,14.912932 9.57396096,14.6897753 L7.59593898,12.7117533 C7.37278224,12.4885966 7.37278224,12.126788 7.59593898,11.9036313 C7.81909572,11.6804746 8.18090428,11.6804746 8.40406102,11.9036313 L9.40659341,12.9061637 L9.40659341,7.09383632 L8.40406102,8.09636871 C8.18090428,8.31952545 7.81909572,8.31952545 7.59593898,8.09636871 C7.37278224,7.87321197 7.37278224,7.51140341 7.59593898,7.28824667 L9.57396096,5.3102247 C9.7971177,5.08706796 10.1589263,5.08706796 10.382083,5.3102247 L12.360105,7.28824667 C12.5832617,7.51140341 12.5832617,7.87321197 12.360105,8.09636871 C12.1369482,8.31952545 11.7751397,8.31952545 11.5519829,8.09636871 L10.5494505,7.09383632 Z M10,18.8571429 C14.8916649,18.8571429 18.8571429,14.8916649 18.8571429,10 C18.8571429,5.10833507 14.8916649,1.14285714 10,1.14285714 C5.10833507,1.14285714 1.14285714,5.10833507 1.14285714,10 C1.14285714,14.8916649 5.10833507,18.8571429 10,18.8571429 Z M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z"
    />
  </svg>
);

MoveIcon.defaultProps = {
  color: colors.mediumGreenhouseGreen,
  width: 20,
  height: 20,
};

export default MoveIcon;
